import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Home from "./views/Home";
import Fold from "./views/Fold";

import Scene from "./components/Scene";

import "./styles/global-styles.scss";

function App() {
  const location = useLocation();
  const [submitted, setSubmitted] = useState(false);

  return (
    <main className="dreamland__wrapper">
      <Scene
        {...{
          submitted,
          setSubmitted,
        }}
      />

      <Routes location={location} key={location.pathname}>
        <Route
          element={<Home key={"home"} {...{ submitted, setSubmitted }} />}
          path="/"
        />
        <Route element={<Fold key={"fold"} {...{}} />} path="/foldoctober24" />
      </Routes>


    </main>
  );
}

export default App;
